import { AwsRdsIconUrl } from "@p0security/shared/integrations/constants";
import { AwsRdsComponents } from "@p0security/shared/integrations/resources/aws-rds/components";

import { Install, InstallProps } from "../Install/Install";
import { awsRdsInstaller } from "./install";

const identifier = () => "identifier";
const itemKind = () => "VPC";

export const AwsRds = (
  props: Pick<
    InstallProps<typeof AwsRdsComponents>,
    "cardOverride" | "onInstall"
  >
) => (
  <Install<typeof AwsRdsComponents>
    components={AwsRdsComponents}
    installer={awsRdsInstaller}
    integration="aws-rds"
    itemKind={itemKind}
    identifier={identifier}
    logo={AwsRdsIconUrl}
    title="Amazon RDS"
    {...props}
  />
);
